import EN from '../data/quizEN.json'
import FR from '../data/quizFR.json'

export const data = {
  state: { EN, FR },
}
